import { FC } from 'react';
// components
import BottleSizeComponent from 'components/main/BottleSize/Edit';

const AddBottleSize: FC = () => <BottleSizeComponent />;

export default AddBottleSize;
